module.exports = __webpack_public_path__ + "img/trainer.f24182ad.png";